import React from 'react';
import { useParams } from 'react-router-dom';
import { Header } from '../Common';
import BulkProduct from '../../Common/BulkProduct';
import { getBulkProduct } from './bulkProductData';
import { SIZE_GUIDE_TITLE, SIZE_GUIDE_ITEMS } from '../Product/sizeGuideData';

/**
 * CLS-DK BulkProduct — thin brand wrapper.
 * Layout + logic live in `Clothing/Common/BulkProduct`.
 */
const CLSDKBulkProduct = () => {
  const { slug } = useParams();
  const product = getBulkProduct(slug);

  return (
    <BulkProduct
      product={product}
      brand="CLS"
      cartBrandSlug="clsdk"
      priceSuffix=",-"
      Header={Header}
      labels={{
        sizeTitle: 'Vælg størrelse',
        sizeGuide: 'Størrelsesguide',
        infoTemplate: (n) => `Bestil mindst ${n} stk. af dette produkt.`,
        buttonLabel: 'Tilføj til kurv',
        minError: (n) => `Mindst ${n} stk. i alt`,
        notFound: 'Produkt ikke fundet.',
        // "Køb risikofrit" block hidden on CLS DK (2026-10-05, user decision).
        riskFree: null,
        delivery: {
          time: 'Leveres fragtfrit',
          cost: '',
          description: '',
          footer: true,
        },
      }}
      sizeGuide={{ title: SIZE_GUIDE_TITLE, items: SIZE_GUIDE_ITEMS }}
    />
  );
};

export default CLSDKBulkProduct;
